module.exports = __webpack_public_path__ + "static/img/meeting-notice.73b15b74.jpg";